import type { TranslationKey } from '@/lib/i18n';

export const PACK_CART_GROUP_COLOR = [
  'sidecart:cart.color',
  'Color: {{color}}',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_SIZE = [
  'sidecart:cart.size',
  'Size: {{size}}',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_PACK_FALLBACK = [
  'sidecart:cart.packFallback',
  'Pack {{id}}',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_REMOVE_PACK = [
  'sidecart:cart.removePack',
  'Remove pack',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_DECREASE_QUANTITY = [
  'sidecart:cart.decreaseQuantity',
  'Decrease quantity',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_INCREASE_QUANTITY = [
  'sidecart:cart.increaseQuantity',
  'Increase quantity',
] as const satisfies TranslationKey;

export const PACK_CART_GROUP_PACK_APPLIED = [
  'sidecart:cart.packApplied',
  'Bundle kit applied',
] as const satisfies TranslationKey;
